import { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(sessionStorage.getItem("token") || null);
  const [username, setUsername] = useState(sessionStorage.getItem("username") || null);

  useEffect(() => {
    if (auth) sessionStorage.setItem("token", auth);
    else sessionStorage.removeItem("token");
  }, [auth]);

  useEffect(() => {
    if (username) sessionStorage.setItem("username", username);
    else sessionStorage.removeItem("username");
  }, [username]);

  const login = (token, profile) => {
    setAuth(token);
    setUsername(profile?.username || null);
    sessionStorage.setItem("token", token);
    if (profile?.username) sessionStorage.setItem("username", profile.username);
  };

  const logout = () => {
    sessionStorage.clear();
    setAuth(null);
    setUsername(null);
  };

  return (
    <AuthContext.Provider value={{ auth, username, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
